export const SET_IS_VS_POPUP = 'SET_IS_VS_POPUP';
export const SET_VS_POPUP_CONTENT = 'SET_VS_POPUP_CONTENT';
export const SET_VS_POPUP_HEIGHT = 'SET_VS_POPUP_HEIGHT';
export const SET_VS_POPUP_DETAILS = 'SET_VS_POPUP_DETAILS';

export const setIsVSPopup = isVSPopup => {
  return dispatch => {
    dispatch({ type: SET_IS_VS_POPUP, payload: isVSPopup });
  };
};
export const setVSPopupContent = content => {
  return dispatch => {
    dispatch({ type: SET_VS_POPUP_CONTENT, payload: content });
  };
};
export const setVSPopupHeight = value => {
  return dispatch => {
    dispatch({ type: SET_VS_POPUP_HEIGHT, payload: value });
  };
};

export const setVSPopupDetails = obj => {
  return dispatch => {
    dispatch({ type: SET_VS_POPUP_DETAILS, payload: obj });
  };
};
